import { declareParams } from '@farfetched/core';
import { zodContract } from '@farfetched/zod';
import { createAuthMutation } from '../auth-http-client';
import { walletSchema } from '../types';

export type EditWalletMutationParams = {
	id: number;
	numberOfBets: number;
	turnover: number;
	cashdeskProfit: number;
};

export const createEditWalletMutation = () =>
	createAuthMutation({
		params: declareParams<EditWalletMutationParams>(),
		request: {
			method: 'PATCH',
			url: ({ id }) => `account/wallet/${id}`,
			body: (params) => ({
				numberOfBets: params.numberOfBets,
				turnover: params.turnover,
				cashdeskProfit: params.cashdeskProfit,
			}),
		},
		response: {
			contract: zodContract(walletSchema),
		},
	});
